import { render } from "./ImportColisStockPage.vue?vue&type=template&id=6617e548&ts=true"
import script from "./ImportColisStockPage.vue?vue&type=script&lang=ts"
export * from "./ImportColisStockPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__